module.exports = require('./helpers/bundle-url').getBundleURL('lly8x') + "adminPro.5a03a17b.png" + "?" + Date.now();